import React from 'react';
import styles from './sport-rules.module.css';
import PageWrapper from '../PageWrapper';

const KambySportRules = () => {
  const pdfPath = 'https://www.pickwin.mx/pdf/kambi-tc-v2.1.pdf';
  
  // Construir la URL de Google Docs Viewer con la URL absoluta del PDF
  const googleDocsViewerUrl = `https://docs.google.com/viewer?url=${encodeURIComponent(pdfPath)}&embedded=true`;

  return (
    <PageWrapper>
      <iframe
        src={googleDocsViewerUrl}
        width="100%"
        className={styles.sportRulesContainer}
        title="Kambi Sport Rules"
        allow="fullscreen"
      />
    </PageWrapper>
  );
};

export default KambySportRules;
